import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export const ignoreExisitingRegularPaymentForSubAccountSubTypes: Array<SubAccountType> = [
    SubAccountType.Npr,
    SubAccountType.JuniorSipp,
    SubAccountType.CashIsa,
    SubAccountType.PersonalPortfolio,
    SubAccountType.WrapCash,
    SubAccountType.StocksIsa,
    SubAccountType.InvestmentAccount
]